import React from "react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { MessageCircle, Mail, Instagram } from "lucide-react";
const channels = [{
  id: "whatsapp",
  name: "Message Us",
  icon: MessageCircle,
  href: "https://web.whatsapp.com/",
  responseTime: "+60 19 327 0771"
}, {
  id: "email",
  name: "Email Us",
  icon: Mail,
  href: "mailto:shaik49@gmail.com",
  responseTime: "SHKAZRIN@GMAIL.COM"
}, {
  id: "instagram",
  name: "Visit Us",
  icon: Instagram,
  href: "/ContactPage",
  responseTime: "Damansara Perdana"
}];
export default function CanalesDirectos() {
  return <section data-section-id="227755" id="reach-our-office" className="bg-background text-foreground py-24 px-4 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-gradient-to-r from-transparent via-primary/50 to-transparent opacity-50" />
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-gradient-to-r from-transparent via-secondary/50 to-transparent opacity-50" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-primary/5 blur-[120px] rounded-full pointer-events-none" />

      <div className="container mx-auto max-w-5xl relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-default font-bold mb-6 tracking-tight text-foreground">
            Reach Our{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-primary/70">
              Office
            </span>
          </h2>
          <p className="text-muted-foreground font-default text-lg max-w-2xl mx-auto">Connect with Shaik Azrin &amp; Co for professional legal counsel.</p>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-12 md:gap-20">
          {channels.map((channel, i) => <div data-index={i} key={channel.id} className="flex flex-col items-center gap-6 group">
              <Link to={channel.href} newTab={i === 0 || channel.id !== "instagram"} className="relative flex items-center justify-center size-28 md:size-36 rounded-full bg-secondary border border-primary/20 backdrop-blur-xl transition-all duration-500 ease-out group-hover:scale-110 group-hover:bg-secondary/80 group-hover:border-primary shadow-2xl shadow-black/50 group-hover:shadow-primary/20">
                {}
                <div className="absolute inset-0 rounded-full border border-primary/0 transition-all duration-500 group-hover:border-primary/30 group-hover:scale-90" />
                
                <channel.icon className="size-12 md:size-14 text-foreground transition-colors duration-500 group-hover:text-primary" strokeWidth={1.5} />
              </Link>

              <div className="flex flex-col items-center gap-3">
                <span className="font-default font-semibold text-xl tracking-wide text-foreground">
                  {channel.name}
                </span>
                <Badge variant="outline" className="border-primary/30 bg-primary/5 text-primary backdrop-blur-md px-3 py-1 text-xs font-mono uppercase tracking-wider rounded-none">
                  {channel.responseTime}
                </Badge>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}